import defaultsDeep from 'lodash/defaultsDeep'
import cloneDeep from 'lodash/cloneDeep'
import actionTypes from 'constants/actionTypes'

interface SearchUser {
  id?: string
  username?: string
  [key: string]: unknown
}

interface UsersSearchState {
  results: SearchUser[]
  isFetching: boolean
}

interface UsersSearchAction {
  type?: string
  payload?: {
    data?: SearchUser[]
  }
}

const initialState: UsersSearchState = {
  results: [],
  isFetching: false,
}

export default (state: UsersSearchState = initialState, action: UsersSearchAction): UsersSearchState => {
  switch (action.type) {
    case actionTypes.USERS.SEARCH.REQUEST:
      return defaultsDeep(
        {
          isFetching: true
        },
        state
      )
    case actionTypes.USERS.SEARCH.RECEIVE: {
      if (!state.isFetching) return state
      const updated = cloneDeep(state)
      updated.isFetching = false
      updated.results = action.payload?.data ?? []
      return updated
    }
    case actionTypes.USERS.SEARCH.FAIL:
      return defaultsDeep(
        {
          isFetching: false
        },
        state
      )
    case actionTypes.USERS.SEARCH.CLEAR: {
      const updated = cloneDeep(state)
      updated.results = []
      updated.isFetching = false
      return updated
    }
  }
  return state
}
